import requestFunctions from "../../functions/requestFunctions";


export const state = {
  OPERATORS_ITEM: {},
  OPERATORS_LIST: [],
  OPERATORS_TABLE_DATA: [],
  OPERATORS_LIST_DATA: [],
  OPERATORS_TOTAL_ROWS: 0
}

export const getters = {
  GET_OPERATORS_ITEM: (state) => {
    return state.OPERATORS_ITEM;
  },
  GET_OPERATORS_LIST: (state) => {
    return state.OPERATORS_LIST;
  },
  GET_OPERATORS_TABLE_DATA: (state) => {
    return state.OPERATORS_TABLE_DATA;
  },
  GET_OPERATORS_LIST_DATA: (state) => {
    return state.OPERATORS_LIST_DATA;
  },
  GET_OPERATORS_TOTAL_ROWS: (state) => {
    return state.OPERATORS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_OPERATORS_ITEM(state, item) {
    state.OPERATORS_ITEM = item;
  },

  UPDATE_OPERATORS_LIST(state, list) {
    
    state.OPERATORS_LIST = list.data;

    state.OPERATORS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.OPERATORS_TABLE_DATA = [];
    state.OPERATORS_LIST_DATA = [];

    list.forEach(el => {

      state.OPERATORS_TABLE_DATA.push({
        'code' : el.code,
        'name' : el.name,
        'uuid' : el.uuid
      });

      state.OPERATORS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_OPERATORS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/operators/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_OPERATORS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_OPERATORS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/operators';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_OPERATORS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_OPERATORS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/operators';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_OPERATORS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/operators/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_OPERATORS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/operators/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}